import React, {useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_BottomToolbar,
    MRT_GlobalFilterTextField,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import CurrencyService from "../../../../../API/common/CurrencyService";
import SupplierService from "../../../../../API/orders/warehouse/supplier/SupplierService";
import WarehouseService from "../../../../../API/orders/warehouse/WarehouseService";
import OrderUtil from "../../../../../utils/orders/OrderUtil";
import {materialReserveState} from "../../../../../data/MaterialReserveState";
import MenuItem from "@mui/material/MenuItem";
import IssuingEdgeService from "../../../../../API/orders/prodaction.issueedge/issueedge/IssuingEdgeService";
import ModalIssuing from "../../../modal/ModalIssuing";

const IssuingEdgeMaterialMaterialReserveTable = ({
                                                     data,
                                                     setData,
                                                     isColumnOrder,
                                                     isColumnMaterialWarehouse,
                                                     isColumnOptimization,
                                                     enableGrouping,
                                                     expanded,
                                                     pageSize,
                                                     orderList,
                                                     change,
                                                     setChange,
                                                     columnGrouping,
                                                     titleModalUpdateOrAddMaterialArrival,
                                                     tableOptions,
                                                     tableOptionsHandle,
                                                     handleModalAlert,
                                                     id,
                                                     loading,
                                                     setLoading
                                                 }) => {

    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [currencyList, setCurrencyList] = useState([]);
    const [supplierList, setSupplierList] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);


    const [modalIssuing, setModalIssuing] = useState(false)

    const handleIssuing = (row) => {
        setCurrentEditRowData(row)
        setModalIssuing(true)
    }

    const handleSubmit = (issue, materialWarehouseId, close) => {
        setLoading(true)

        IssuingEdgeService.issuanceEdgeRetailByReserve(id, materialWarehouseId, currentEditRowData.id, issue).then(function (response) {
            handleModalAlert("Выдано", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error, 'error')
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        CurrencyService.getAll().then(function (response) {
            let data = response.data;
            data.sort((a, b) =>
                a.defaultBase === b.defaultBase ? 0 : a.defaultBase ? -1 : 1
            );
            setCurrencyList(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
        SupplierService.get().then(function (response) {
            let data = response.data;
            setSupplierList(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
        WarehouseService.getAll().then(function (response) {
            let data = response.data;
            setWarehouseList(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const menuItem = [
        {type: "issuing", text: "Выдать", handler: handleIssuing},
    ]
    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'materialArticleNumber',
                header: 'Артикул',
                accessorKey: 'materialArticleNumber',
                minSize: 70,
            },
            {
                id: 'materialName',
                header: 'Наименование',
                accessorKey: 'materialName',
                minSize: 70,

            },
            {
                id: 'quantity',
                header: 'Необходимо.',
                accessorKey: 'quantity',
                minSize: 15,
                maxSize: 15,
                aggregationFn: 'sum',
                AggregatedCell: ({cell, table}) => (
                    <>
                        <Box sx={{
                            color: 'primary.main',
                            fontWeight: 'bold'
                        }}>
                            {cell.getValue()?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </>
                ),
            },
            {
                id: 'availabilityQuantity',
                header: 'Наличие',
                accessorKey: 'availabilityQuantity',
                minSize: 15,
                maxSize: 15,
                aggregationFn: 'sum',
                AggregatedCell: ({cell, table}) => (
                    <>
                        <Box sx={{
                            color: 'success.main',
                            fontWeight: 'bold'
                        }}>
                            {cell.getValue()?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 3,
                            })}
                        </Box>
                    </>
                ),
            },
            {
                id: 'materialReserveState',
                header: 'Статус',
                accessorKey: 'materialReserveState',
                minSize: 55,
                maxSize: 55,
                Cell: ({cell}) => materialReserveState[cell.getValue()],
                filterFn: (row, id, filterValue) => {
                    return materialReserveState[row.original.materialReserveState].toLowerCase().includes(filterValue.toLowerCase())
                },
            },
            {
                id: 'orderNumber',
                header: 'Заказы',
                accessorKey: 'orders',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    return OrderUtil.convertNumberOrders(cell.getValue())
                },
                filterVariant: 'multi-select',
                filterSelectOptions: orderList,
                filterFn: (row, id, filterValue) => {
                    return OrderUtil.checkNumberOrder(row.getValue(id), filterValue)
                },
            },
            {
                id: 'plan.number',
                header: 'План',
                accessorKey: 'plan.number',
                minSize: 15,
                maxSize: 15,
            },

            {
                header: 'id',
                id: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
            },
        ];

        return baseColumns;

    }, [data, setData, isColumnOrder]);

    return (
        <div>
            <MaterialReactTable
                muiTableBodyCellProps={({cell, table}) => {
                    return ({

                        sx: () => ({
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',
                            },
                            "&": cell.column.id === "requests_cutting" && {
                                width: 'calc(100% - 1px)',
                                padding: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            },

                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }

                            }
                        })
                    })
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}

                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 10,
                        grow: false,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                muiToolbarAlertBannerProps={{
                    sx: {
                        backgroundColor: (theme) => theme.palette.primary.light,
                        "& .MuiStack-root": {
                            padding: 0,
                        },
                    }
                }}
                renderTopToolbar={({table}) => {
                    const backgroundBlue = table.getState().grouping.length > 0 || table.getSelectedRowModel().rows.length > 0
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => backgroundBlue ? theme.palette.primary.light : "transparent",
                        "& .MuiStack-root": {
                            padding: "1px",
                            flexDirection: "row-reverse",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "40px",
                        },
                    }}>
                        <MRT_ToolbarAlertBanner
                            table={{...table, options: {...table.options, rowCount: tableOptions.totalElements}}}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                renderBottomToolbar={({table}) => {
                    const tableProps = table.getState().grouping.length > 0
                        ? {
                            ...table,
                            options: {
                                ...table.options,
                                localization: {
                                    ...table.options.localization,
                                    rowsPerPage: `Всего строк: ${tableOptions.totalElements}. Сгруппированных элементов на странице:`
                                }
                            }
                        }
                        : table
                    return <MRT_BottomToolbar table={tableProps}/>
                }}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    return <MenuItem
                        key={el.type}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })}
                selectAllMode={'all'}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                paginateExpandedRows={false}
                state={{showGlobalFilter: true, pagination: tableOptions,}}
                columns={columns}
                data={data}
                rowHeight={13}
                columnSpacing={1}
                enableToolbarInternalActions={false}
                initialState={{
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                    expanded: expanded,
                    grouping: columnGrouping,
                }}
                enableRowActions={true}
                enableGrouping={enableGrouping}
                localization={MRT_Localization_RU}
                getRowId={(originalRow) => originalRow.id}
            />

            {modalIssuing && <ModalIssuing
                open={modalIssuing}
                onClose={() => setModalIssuing(false)}
                title={'Выдать'}
                initValues={currentEditRowData}
                handleSubmit={handleSubmit}
                handleModalAlert={handleModalAlert}
                loading={loading}
            />}
        </div>
    );
};

export default IssuingEdgeMaterialMaterialReserveTable;